export interface Profile {
    name: string;
    nickname: string;
    email: string;
    sub: string;
    picture: string;
    updated_at: Date;
    email_verified: boolean;
    'http://api.hill-laboratories.co.nz/userCrmContactId': string;
}

export const EMPTY_PROFILE = {
    name: '',
    nickname: '',
    email: '',
    sub: null
} as Profile;
